import { pBase } from './.catalog';

export default class pCore extends pBase {
  public constructor() {
    super();
  }
}
